import { AnimationController, Animation } from '@ionic/angular';

export const modalEnterAnimation = (baseEl: HTMLElement): Animation => {

    const DURATION = 250;

    const animationCtrl = new AnimationController();

    const enterAnimation = animationCtrl.create()
        .addElement(baseEl.querySelector('.modal-wrapper'))
        .duration(DURATION)
        .easing('ease-in-out')
        .fromTo('transform', 'translateX(-100%)', 'translateX(0)');

    return animationCtrl.create().addAnimation(enterAnimation);
};

export const modalLeaveAnimation = (baseEl: HTMLElement): Animation => {

    const DURATION = 250;

    const animationCtrl = new AnimationController();

    const leavingAnimation = animationCtrl.create()
        .addElement(baseEl.querySelector('.modal-wrapper'))
        .duration(DURATION)
        .easing('ease-out')
        .fromTo('transform', 'translateX(0)', 'translateX(-100%)');

    return animationCtrl.create().addAnimation(leavingAnimation);
};

export const modalEnterAnimationVertical = (baseEl: HTMLElement): Animation => {

    const DURATION = 250;

    const animationCtrl = new AnimationController();

    const enterAnimation = animationCtrl.create()
        .addElement(baseEl.querySelector('.modal-wrapper'))
        .duration(DURATION)
        .easing('ease-in-out')
        .fromTo('transform', 'translateY(100%)', 'translateY(0)');

    return animationCtrl.create().addAnimation(enterAnimation);
};

export const modalLeaveAnimationVertical = (baseEl: HTMLElement): Animation => {

    const DURATION = 250;

    const animationCtrl = new AnimationController();

    const enterAnimation = animationCtrl.create()
        .addElement(baseEl.querySelector('.modal-wrapper'))
        .duration(DURATION)
        .easing('ease-in-out')
        .fromTo('transform', 'translateY(0)', 'translateY(100%)');

    return animationCtrl.create().addAnimation(enterAnimation);
};
